// src/index.ts
var PREFIX = "debug:";
function hasLocalStorage() {
  try {
    return typeof localStorage !== "undefined" && localStorage !== null;
  } catch {
    return false;
  }
}
function getProcessEnv() {
  try {
    if (typeof process !== "undefined" && process.env !== void 0) {
      return process.env;
    }
  } catch {
  }
  return null;
}
function moduleToEnvKey(module) {
  return "DEBUG_" + module.replace(/[:-]/g, "_").toUpperCase();
}
function isEnabled(module) {
  const key = `${PREFIX}${module}`;
  if (hasLocalStorage()) {
    const val = localStorage.getItem(key);
    if (val === null) {
      localStorage.setItem(key, "1");
      return true;
    }
    return val === "1";
  }
  const env = getProcessEnv();
  if (env) {
    const envKey = moduleToEnvKey(module);
    const val = env[envKey];
    if (val === void 0) return true;
    return val === "1";
  }
  return true;
}
function createLogger(module) {
  return {
    log(...args) {
      if (isEnabled(module)) {
        console.log(`[${module}]`, ...args);
      }
    },
    warn(...args) {
      if (isEnabled(module)) {
        console.warn(`[${module}]`, ...args);
      }
    },
    error(...args) {
      if (isEnabled(module)) {
        console.error(`[${module}]`, ...args);
      }
    }
  };
}
function setDebugEnabled(module, enabled) {
  const key = `${PREFIX}${module}`;
  if (hasLocalStorage()) {
    localStorage.setItem(key, enabled ? "1" : "0");
  } else {
    const env = getProcessEnv();
    if (env) {
      env[moduleToEnvKey(module)] = enabled ? "1" : "0";
    }
  }
}
function isDebugEnabled(module) {
  const key = `${PREFIX}${module}`;
  if (hasLocalStorage()) {
    const val = localStorage.getItem(key);
    return val === null ? true : val === "1";
  }
  const env = getProcessEnv();
  if (env) {
    const envKey = moduleToEnvKey(module);
    const val = env[envKey];
    return val === void 0 ? true : val === "1";
  }
  return true;
}
function listDebugModules() {
  const result = [];
  if (hasLocalStorage()) {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(PREFIX)) {
        const module = key.slice(PREFIX.length);
        result.push({ module, enabled: localStorage.getItem(key) === "1" });
      }
    }
  } else {
    const env = getProcessEnv();
    if (env) {
      for (const envKey of Object.keys(env)) {
        if (envKey.startsWith("DEBUG_")) {
          const module = envKey.slice("DEBUG_".length).toLowerCase().replace(/_/g, "-");
          const val = env[envKey];
          result.push({ module, enabled: val === "1" });
        }
      }
    }
  }
  return result.sort((a, b) => a.module.localeCompare(b.module));
}
export {
  createLogger,
  isDebugEnabled,
  listDebugModules,
  setDebugEnabled
};
